import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import App from "./App";
import "./styles.css";

const root = createRoot(document.getElementById("root")!);
root.render(
  <StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </StrictMode>,
);

if (import.meta.env.VITE_SENTRY_DSN) {
  window.setTimeout(() => {
    void import("@sentry/react").then((Sentry) => {
      Sentry.init({
        dsn: import.meta.env.VITE_SENTRY_DSN,
        environment: import.meta.env.VITE_SENTRY_ENVIRONMENT ?? "local",
        sendDefaultPii: false,
        integrations: [Sentry.browserTracingIntegration(), Sentry.feedbackIntegration({ autoInject: false, showBranding: false })],
        tracesSampleRate: 0.05,
      });
    });
  }, 1_000);
}
